"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_frontend_shared_1 = require("@synisys/idm-frontend-shared");
function userHelpItemFromObject(userHelpItemObject) {
    return {
        url: userHelpItemObject['url'],
        title: idm_frontend_shared_1.buildMultilingualStringFromObject(userHelpItemObject['title']),
        documentId: userHelpItemObject['documentId'],
    };
}
exports.userHelpItemFromObject = userHelpItemFromObject;
//# sourceMappingURL=user-help-item.model.js.map